import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ShieldCheck, LogOut, LayoutDashboard, Mail, Phone, Instagram } from "lucide-react";

const STAFF = ["admin", "gutachter", "support"];

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <>
      <div className="bg-[#0A192F] text-slate-300 text-xs border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-9 flex items-center justify-end gap-5">
          <a href="mailto:frank.saier@outlook.de" data-testid="topbar-email" className="flex items-center gap-1.5 hover:text-emerald-400 transition-colors"><Mail size={13} /> frank.saier@outlook.de</a>
          <a href="tel:+49766162209" data-testid="topbar-phone" className="flex items-center gap-1.5 hover:text-emerald-400 transition-colors"><Phone size={13} /> 07661 62209</a>
          <a href="https://instagram.com/gruendungszuschuss48h" target="_blank" rel="noopener noreferrer" data-testid="topbar-instagram" className="flex items-center gap-1.5 hover:text-emerald-400 transition-colors"><Instagram size={13} /> Instagram</a>
        </div>
      </div>
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-border/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 font-display font-extrabold text-lg text-[#0A192F]">
          <span className="grid place-items-center h-9 w-9 rounded-md bg-[#0A192F] text-white"><ShieldCheck size={20} /></span>
          Gründungszuschuss<span className="text-emerald-500">48h</span>
        </Link>
        <nav className="flex items-center gap-2 sm:gap-3">
          {user && user !== false ? (
            <>
              {STAFF.includes(user.role) && (
                <Button variant="ghost" size="sm" data-testid="nav-admin" onClick={() => nav("/admin")}>
                  <LayoutDashboard size={16} className="mr-1" /> Admin
                </Button>
              )}
              <Button variant="ghost" size="sm" data-testid="nav-portal" onClick={() => nav("/portal")}>Mein Portal</Button>
              <Button variant="outline" size="sm" data-testid="nav-logout" onClick={async () => { await logout(); nav("/"); }}>
                <LogOut size={16} className="mr-1" /> Abmelden
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" data-testid="nav-login" onClick={() => nav("/login")}>Anmelden</Button>
              <Button size="sm" className="bg-emerald-500 hover:bg-emerald-600 text-white" data-testid="nav-start" onClick={() => nav("/antrag")}>
                Jetzt starten
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
    </>
  );
}
